const LOCAL_FLY_QL_URL = 'http://localhost:3059/fly-ql/graph/query'
const PCLN_GRAPH_URL = '/pws/v0/pcln-graph/'
const FLY_QL_URL = '/pws/v0/fly/graph/query'
const AIR_PRICE_GUIDE_URL = '/pws/v0/fly/priceguide/graph/query'
const GRAPH_CDN_PROD = 'https://www.priceline.com/graphcdn'

const GRAPH_CDN_QA = 'https://qaa.priceline.com/graphcdn'

const GRAPH_CDN_SETI = {
  airPriceGuideRetailOW: 'AIR_PCLN_GRAPH_CDN_OW',
  airPriceGuideRetailRT: 'AIR_PCLN_GRAPH_CDN_RT',
}

export {
  PCLN_GRAPH_URL,
  GRAPH_CDN_PROD,
  GRAPH_CDN_QA,
  GRAPH_CDN_SETI,
  FLY_QL_URL,
  AIR_PRICE_GUIDE_URL,
  LOCAL_FLY_QL_URL,
}
